import { productCard } from "./product-card";
import { invoicecCardInfo } from "./invoice-card-info";
import { duplicatesCardInfo } from "./duplicates-card-info";
import { paymentCardInfo } from "./payment-card-info";

export const importXml = {
	title: "Importación de factura fiscal",
	stockItens: "Elementos del inventario",
	productCard,
	invoicecCardInfo,
	duplicatesCardInfo,
	paymentCardInfo,
};
